export default "__VITE_ASSET__bHQMbJEf__"